import React, { PropTypes } from 'react';
import InlineValidationMessage from '../../common/InlineValidationMessage';
import FormErrorNotification from '../FormErrorNotification';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import sqlServerAuthTypes from './sqlServerAuthTypes';
import selectionElementMode from '../selectionElementMode';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { InputFieldWithValidation } from '../FormComponents';
import AgentSelection from '../AgentSelection';
import LoaderWithText from '../LoaderWithText';

const AgentSelectionField = (props) => {
    return <div>
        <AgentSelection value={props.input.value} autoFocus={props.autoFocus} onChange={props.input.onChange} onModeChanged={props.onModeChanged} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
    </div>;
};

const AuthenticationTypeSelect = React.createClass({
    handleOnChange: function (e) {
        this.props.input.onChange(e.target.value);
    },
    render: function () {
        const { input, meta: { touched, error } } = this.props;
        return (
            <div>
                <div>
                    <input id="authenticationtype-windows" type="radio" name="authenticationtype"
                        value={sqlServerAuthTypes.agentWindows}
                        onChange={this.handleOnChange}
                        checked={input.value === sqlServerAuthTypes.agentWindows} />

                    <label htmlFor="authenticationtype-windows">Windows Authentication</label>
                </div>
                <div>
                    <input id="authenticationtype-sqlserver" type="radio" name="authenticationtype"
                        value={sqlServerAuthTypes.sqlServer}
                        onChange={this.handleOnChange}
                        checked={input.value === sqlServerAuthTypes.sqlServer} />

                    <label htmlFor="authenticationtype-sqlserver">SQL Server Authentication</label>
                </div>

                <InlineValidationMessage touched={touched} error={error} />
            </div>
        );
    }
});

const SqlServerInstanceForm = React.createClass({
    propTypes: {
        actionName: PropTypes.string.isRequired,
        onValid: PropTypes.func,
        onCancel: PropTypes.func
    },
    getInitialState: function () {
        return {
            isOnAgentAddMode: false
        };
    },
    onAgentSelectionModeChanged: function (mode) {
        this.setState({ isOnAgentAddMode: mode === selectionElementMode.add });
    },
    render: function () {
        const { authenticationType, selectedAgentUsername, handleSubmit, onValid, submitting, pristine, error, initialValues, actionName, onCancel } = this.props;
        const { isOnAgentAddMode } = this.state;
        const isInstanceDisabled = !isUndefinedNullOrEmpty(initialValues.instanceName);

        return <div>
            <FormErrorNotification error={error} />

            {!isOnAgentAddMode && <div>
                <h2>Add new SQL Server instance</h2>

                {isInstanceDisabled && <div className="control-holder">
                    <label>Server Instance</label>
                    <input type="text" value={initialValues.instanceName} disabled />
                </div>}
            </div>}

            {!isInstanceDisabled && <div className="control-holder">
                <Field name="agentId" placeholder="Select an agent" autoFocus onModeChanged={this.onAgentSelectionModeChanged} component={AgentSelectionField} />
            </div>}

            {(!isOnAgentAddMode && !isInstanceDisabled) && <div className="control-holder">
                <Field name="instanceName" type="text" label="SQL Server Instance Name"
                    placeholder="e.g. sql2014 (leave blank for default instance)" component={InputFieldWithValidation} />
            </div>}

            {!isOnAgentAddMode && <div>
                <Field name="authenticationType" component={AuthenticationTypeSelect} />

                {authenticationType === sqlServerAuthTypes.agentWindows && <div>
                    <div className="control-holder">
                        <input type="text" value={selectedAgentUsername} disabled />
                    </div>
                </div>}

                {authenticationType === sqlServerAuthTypes.sqlServer && <div>
                    <div className="control-holder">
                        <Field name="sqlServerLogin" type="text" label="Login" component={InputFieldWithValidation} />
                    </div>

                    <div className="control-holder">
                        <Field name="password" type="password" label="Password" component={InputFieldWithValidation} />
                    </div>
                </div>}

                <div className="button-holder">
                    <button className="button button--primary" disabled={pristine || submitting} onClick={handleSubmit(onValid)}>
                        {actionName}
                    </button>
                    <button className="nobutton button--flat-secondary" disabled={submitting} onClick={onCancel}>
                        Cancel
                    </button>
                </div>

                {submitting && <div className="control-holder">
                    <LoaderWithText loadingText="Checking connection" />
                </div>}
            </div>}
        </div>;
    }
});

const mapStateToProps = (state) => {
    const selector = formValueSelector('SqlServerInstanceForm');
    const agentId = selector(state, 'agentId');
    const selectedAgent = !isUndefinedNullOrEmpty(agentId) ? state.agents.value.get(agentId) : null;

    return {
        authenticationType: selector(state, 'authenticationType'),
        selectedAgentUsername: !isUndefinedNullOrEmpty(selectedAgent) ? selectedAgent.status.windowsUsername : ''
    };
};

const component = connect(mapStateToProps)(SqlServerInstanceForm);

export default reduxForm({
    form: 'SqlServerInstanceForm'
})(component);



// WEBPACK FOOTER //
// ./src/components/common/SqlServerInstanceSelection/SqlServerInstanceForm.jsx